import { key, notify } from '@databases/ping-registry';
import { createSelectionsPingEffect } from '@databases/selections';

import { SelectionFeatureKeys, type SelectionEffectFeature } from '../../features/types';

export function createSelectionsPingEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.SELECTIONS_PING_EFFECT,
    type: 'effect',
    // Always active — selection pings are read-only UI notifications
    // that bridge the selections machine to React components via the
    // ping registry. They don't modify data and are needed for all
    // selection modes to keep the UI in sync.
    factory: () => {
      return createSelectionsPingEffect({
        notifyDatabaseSelectionChanged: () => {
          const databaseKey = key('database', {});

          notify(databaseKey, 'selectionChanged', true);
        },
      });
    },
  };
}
